import { ProductFeature } from "./product-feature";
import { ProductInStore } from "./product-in-store";
export class ProductDataWithFeature {
    constructor(
        public SKU: number = null,
        public Products: ProductInStore[] = []
    ) {
    }
}
